import React, { useEffect, useMemo, useState } from "react";
import { cropToDataUrl, loadImage } from "../imageTools";
import { colors, fonts, space, radius, buttonPrimary, buttonSecondary } from "../theme";

// Crop a chosen photo to a FIXED frame (banner 4:1 or square logo) with zoom and left/right/up/down sliders.
export default function PhotoCropper({ file, outW, outH, maxChars, label, onSave, onCancel }) {
  const [img, setImg] = useState(null);
  const [err, setErr] = useState("");
  const [zoom, setZoom] = useState(1);
  const [ox, setOx] = useState(0);
  const [oy, setOy] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { loadImage(file).then(setImg).catch((e) => setErr(e.message)); }, [file]);
  const preview = useMemo(() => (img ? cropToDataUrl(img, { outW: Math.round(outW / (outW > 400 ? 3 : 1)), outH: Math.round(outH / (outW > 400 ? 3 : 1)), zoom, offsetX: ox, offsetY: oy, maxChars: 60000 }) : null), [img, zoom, ox, oy, outW, outH]);
  const save = async () => {
    setBusy(true);
    try { await onSave(cropToDataUrl(img, { outW, outH, zoom, offsetX: ox, offsetY: oy, maxChars })); } finally { setBusy(false); }
  };
  if (err) return <div role="alert" style={{ color: "#b91c1c", fontFamily: fonts.body, fontSize: 13 }}>{err} <button style={buttonSecondary} onClick={onCancel}>Close</button></div>;
  return (
    <div style={{ background: colors.surfaceMuted, border: `1px solid ${colors.border}`, borderRadius: radius.md, padding: space[3], marginTop: space[2] }} data-testid="cropper">
      <div style={{ fontFamily: fonts.body, fontSize: 13, marginBottom: 6 }}>{label}: drag the sliders to choose what shows in the frame.</div>
      {preview && <img src={preview} alt="Crop preview" style={{ display: "block", maxWidth: "100%", border: `1px solid ${colors.border}`, borderRadius: radius.sm, width: outW > 400 ? "100%" : 160 }} data-testid="crop-preview" />}
      {[["Zoom", zoom, setZoom, 1, 3, 0.05], ["Left / right", ox, setOx, -1, 1, 0.02], ["Up / down", oy, setOy, -1, 1, 0.02]].map(([name, val, set, min, max, step]) => (
        <label key={name} style={{ display: "flex", alignItems: "center", gap: 10, fontFamily: fonts.body, fontSize: 12, marginTop: 6 }}>
          <span style={{ width: 80 }}>{name}</span>
          <input type="range" min={min} max={max} step={step} value={val} onChange={(e) => set(Number(e.target.value))} aria-label={name} style={{ flex: 1 }} />
        </label>
      ))}
      <div style={{ display: "flex", gap: space[2], marginTop: space[3] }}>
        <button style={buttonPrimary} onClick={save} disabled={busy || !img}>{busy ? "Saving…" : "Save picture"}</button>
        <button style={buttonSecondary} onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
